// EnhancedBoxCastFlowControlTooltipHTML is the HTML of the tooltip that explains standard and enhanced
// BoxCast flow control. It is used for creating/editing broadcasts and editing BoxCaster sources.
export const EnhancedBoxCastFlowControlTooltipHTML = `<b>Standard:</b> Minimizes viewer latency; recovers lost data for up to 2 seconds.
  <br/>
  <b>Enhanced:</b> Recovers lost data for up to 15s (and adds 15 seconds to viewer latency).`;

// MaximumBoxCastFlowControlTooltipHTML is the HTML of the tooltip that explains standard, enhanced, and
// maximum BoxCast flow control. It is used for creating/editing broadcasts and editing BoxCaster sources.
export const MaximumBoxCastFlowControlTooltipHTML =
  EnhancedBoxCastFlowControlTooltipHTML +
  `<br/><b>Maximum:</b> Recovers lost data for up to 45-90 seconds (and adds 45-90 seconds to viewer latency).`;



// WEBPACK FOOTER //
// ./app/utils/boxcast_flow_control.js